import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setFilterAValueWithUpdate,
  setFilterBValueWithUpdate,
  setSearchValueWithUpdate,
} from '../../../../redux/actions/filterActions';
import { formatFilterText } from '../../../../utils/formatFilterText';
import { tabHasTag } from '../../../../utils/parseTabTags';
import styles from './index.module.scss';

const DynamicPodheader = ({ data = {}, path = '', onClose, currentSection = '', tag = '' }) => {
  const dispatch = useDispatch();

  // Получаем данные current_tab из Redux store
  const currentTabData = useSelector((state) => state.currentTab);

  // Получаем данные фильтров
  const publicationFilterA = currentTabData.publication_filter_a || [];
  const publicationFilterB = currentTabData.publication_filter_b || [];

  // Получаем текущие значения фильтров из Redux
  const selectedFilterA = currentTabData.filter_a_value || publicationFilterA[0] || '';
  const selectedFilterB = currentTabData.filter_b_value || publicationFilterB[0] || '';
  const searchValue = currentTabData.search_value || '';

  // Локальное состояние для поля поиска (не связано с Redux)
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);

  // Синхронизируем локальное состояние с Redux при изменении search_value
  React.useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  // Обработчики изменения фильтров
  const handleFilterAChange = (event) => {
    dispatch(setFilterAValueWithUpdate(event.target.value));
    setLocalSearchValue(''); // Сбрасываем текст в поле поиска
  };

  const handleFilterBChange = (event) => {
    dispatch(setFilterBValueWithUpdate(event.target.value));
    setLocalSearchValue(''); // Сбрасываем текст в поле поиска
  };

  const handleSearchChange = (event) => {
    // Обновляем только локальное состояние, не Redux
    setLocalSearchValue(event.target.value);
  };

  const handleSearchSubmit = () => {
    // При нажатии кнопки "Искать" обновляем Redux
    dispatch(setSearchValueWithUpdate(localSearchValue));
    // Сбрасываем текст в поле поиска после отправки
    setLocalSearchValue('');
  };

  // Проверяем, нужно ли показывать фильтры (только для тега sh_podheader)
  const shouldShowFilters = tabHasTag(tag, 'sh_podheader');

  // Отладка
  // console.log('DynamicPodheader - publicationFilterA:', publicationFilterA, 'length:', publicationFilterA.length, 'shouldShow:', publicationFilterA.length > 1);

  return (
    <div className={styles.dynamicPodheader}>
      <div className={styles.content}>
        {/* Блок с названием */}
        <div className={styles.titleBlock}>
          <h2 className={styles.title}>
            {(currentTabData.show_name || data.title || 'Динамичный Подзаголовок').toLowerCase()}
          </h2>
          {currentTabData.description || data.description ? (
            <p className={styles.description}>{currentTabData.description || data.description}</p>
          ) : null}
          {onClose && (
            <button className={styles.closeButton} onClick={onClose} title='Закрыть'>
              ×
            </button>
          )}
        </div>

        {/* Блок с фильтрами - показываем только если тег содержит sh_podheader */}
        <div className={styles.filtersBlock}>
          {shouldShowFilters && (
            <>
              {/* Поле поиска слева */}
              <div className={styles.searchContainer}>
                <label className={styles.searchLabel} htmlFor='dynamicSearch'>
                  поиск по разделу:
                </label>
                <div className={styles.searchInputContainer}>
                  <input
                    id='dynamicSearch'
                    type='text'
                    className={styles.searchInput}
                    value={localSearchValue}
                    onChange={handleSearchChange}
                    placeholder='Введите поисковый запрос'
                  />
                  <button
                    type='button'
                    className={styles.searchButton}
                    onClick={handleSearchSubmit}
                    title='Искать'>
                    →
                  </button>
                </div>
              </div>

              {/* Фильтры справа */}
              <div className={styles.filtersGroup}>
                {publicationFilterB.length > 1 && (
                  <div className={styles.radioContainer}>
                    <label className={styles.filterLabel}>показать:</label>
                    <div className={styles.radioGroup}>
                      {publicationFilterB.map((item, index) => (
                        <label key={index} className={styles.radioLabel}>
                          <input
                            type='radio'
                            name='dynamicFilterB'
                            value={item}
                            checked={selectedFilterB === item}
                            onChange={handleFilterBChange}
                            className={styles.radioInput}
                          />
                          <span className={styles.radioText}>{formatFilterText(item)}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}
                {publicationFilterA.length > 1 && (
                  <div className={styles.filterContainer}>
                    <label className={styles.filterLabel} htmlFor='dynamicFilterA'>
                      тип деформации:
                    </label>
                    <select
                      id='dynamicFilterA'
                      className={styles.filterSelect}
                      value={selectedFilterA}
                      onChange={handleFilterAChange}>
                      {publicationFilterA.map((item, index) => (
                        <option key={index} value={item}>
                          {formatFilterText(item)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DynamicPodheader;
